import { createFileRoute } from '@tanstack/react-router'
import ContactAssets from 'Contact/components/Contact/Sections/ContactAssets'
import { claimTypesEnum } from 'User/utils/claims'

import { Guard } from '../../-guard'

export const Route = createFileRoute('/contact/$contactId/assets')({
    component: () => (
        <Guard claims={[claimTypesEnum.enum.opus_asset]}>
            <ContactAssets />
        </Guard>
    ),
})
